export const getIsAuthorizationModalOpen = (state) => {
  return state.authorizationModal.isOpen;
};
